import { useState } from "react";
import { NavLink } from "react-router-dom";



import img1 from './images/cllg1 (1).png';
import img2 from './images/cllg1 (2).png';
import img3 from './images/cllg1 (3).png';
import img4 from './images/cllg1 (4).png';
import img5 from './images/cllg1 (5).png';
import img6 from './images/cllg1 (6).png';
import img7 from './images/col11.webp';
import img8 from './images/col8.webp';
import img9 from './images/col9.webp';
import Boucherpopup from "../Popupform/Boucherpopup";


// college card data 
const college = [
    { link: 'Delhi', img: img1, rank: "Ranked 11 out of 80 TOI" },
    { link: 'TamilNadu', img: img2, rank: "Ranked 150 out of 1400S" },
    { link: 'Chennai', img: img3, rank: "Ranked 609 out of 1400S" },
    { link: 'Pune', img: img4, rank: "Ranked 95 out of 1400S" },
    { link: 'Banglore', img: img5, rank: "Ranked 150 out of 1400S" },
    { link: 'Punjab', img: img6, rank: "Ranked 100 out of 1400S" },
    { link: 'Mumbai ', img: img7, rank: "Ranked 120 out of 1400S" },
    { link: 'Kolkata', img: img8, rank: "Ranked 1200 out of 1400S" },
    { link: 'Bhopal', img: img9, rank: "Ranked 259 out of 1400S" },

];


const Colleges = () => {

    const [visibleCount, setVisibleCount] = useState(6); // Show 8 cards initially

    const loadMoreCards = () => {
        setVisibleCount((prevCount) => prevCount + 4); // Load 4 more cards
    };

    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const handleOpenBoucherPopup = () => setShowBoucherPopup(true);
    const handleCloseBoucherPopup = () => setShowBoucherPopup(false);


    return (
        <div>

            {/* heading container start  */}
            {/* this container css in program.css page  */}
            <div className="container mt-5 pt-5">
                <div className="row ">
                    <div className="col">
                        <div className=''>
                            {/* heading */}
                            <h1 className='exploretitle fs-1'>
                                Top Universities/Colleges
                            </h1>

                            <p className='explore_para text-start'>Discover a curated list of prestigious universities and colleges that set the standard for global education. From cutting-edge research facilities to vibrant campus life, these institutions offer everything you need to excel academically and personally.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* heading container end  */}

            {/* all colleges cards   */}
            <div className="container">
                <div className="row pt-3 colegcontainer">
                    {college.slice(0, visibleCount).map((item, index) => (
                        <div key={index} className="col-md-4 college_col">
                            <div className="card mt-3">
                                <img
                                    src={item.img}
                                    className="card-img-top"
                                    alt={item.name}
                                />
                                <div className="">
                                    <p className="college_rank">
                                        {item.rank}
                                    </p>

                                    <ul className="college_ul">
                                        <li className="college_ul_li">
                                            <div>
                                                <NavLink to="" className="nav-link fw-semibold" > Compare
                                                </NavLink>
                                            </div>
                                        </li>

                                        <li className="college_ul_li">
                                            <div>
                                                <NavLink className="nav-link" onClick={handleOpenBoucherPopup}> Download Boucher</NavLink>

                                            </div>
                                        </li>

                                        <li className="college_ul_li">
                                            <div className="pt-2">
                                                <NavLink to="/TopStudy-colleges"
                                                    state={{
                                                        state: item.link,
                                                        // courseName: item.link.split("colleges in")[0].trim(),
                                                        // state: item.link.split("colleges in")[1]?.trim()
                                                    }}
                                                    className="fw-semibold card-link colcardlink">
                                                    Colleges in {item.link} <i className="fa fa-angle-double-right"></i>
                                                </NavLink>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Boucher Popup */}
                    {showBoucherPopup && (
                        <div className="popup-overlay">
                            <div className="popup-content">
                                <button className="close-btn" onClick={handleCloseBoucherPopup}>
                                    &times;
                                </button>
                                <Boucherpopup />
                            </div>
                        </div>
                    )}

                </div>
            </div>


            {/* Load More Button */}
            {visibleCount < college.length && (
                <div className="text-center">
                    <button
                        className="mybtn mt-4"
                        onClick={loadMoreCards}>
                        Load More Colleges
                    </button>
                </div>
            )}
        </div>
    )
}

export default Colleges
